import { SxProps, Theme, Tooltip, Typography } from '@mui/material'
import get from 'lodash/get'
import { useTranslate } from 'ra-core'
import { RaRecord, useRecordContext } from 'react-admin'

interface AdvancedTextFieldProps {
  source: string
  className?: string
  fallback?: string
  map?: Record<string, string>
  multiline?: boolean
  sx?: SxProps<Theme>
  tooltip?: string
  record?: RaRecord
}

const AdvancedTextField = ({
  className,
  fallback = 'n/a',
  map,
  multiline = false,
  source,
  sx,
  tooltip = '',
  ...props
}: AdvancedTextFieldProps) => {
  const record = useRecordContext(props)
  const translate = useTranslate()
  let value: string = get(record, source)
  value = (map ? map[value] : value) || fallback
  if (multiline) {
    value = value.split('\\n').join('\n')
  }
  return (
    <Typography component="span" variant="body2" className={className} sx={sx}>
      <Tooltip title={tooltip}>
        <span style={multiline ? { whiteSpace: 'pre-wrap' } : undefined}>{translate(value, { _: value })}</span>
      </Tooltip>
    </Typography>
  )
}

export default AdvancedTextField
